/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'doT',
	'./MediaBase',
	'text!./Media.html'
], (_, dot, MediaBase, Template) => {

	const template = dot.template(Template);

	class EmbedMedia extends MediaBase {

		constructor(url, id, videoTemplate, extraTemplateArguments) {
			super(...arguments);
			this.videoTemplate = dot.template(videoTemplate);
			this.extraTemplateArguments = extraTemplateArguments || {};
		}

		getDimensions() {
			return Promise.resolve(null);
		}

		getMarkup(params) {
			_.extend(params,
				this.extraTemplateArguments, {
					url: this.url
				}
			);

			return template({
				mediaMarkup: this.videoTemplate(params)
			});
		}

		markupLoaded($el /*, mode*/ ) {
			this.$el = $el;
			super.markupLoaded(...arguments);
		}

		showAuthoringMode() {
			const mediaTag = this.$el.find('iframe.youtubePlayer, video, audio');
			if (mediaTag[0]) {
				switch (mediaTag[0].tagName) {
					case 'IFRAME':
						{
							const iFrame = mediaTag[0].contentWindow;
							iFrame.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						}
						break;
					case 'VIDEO':
					case 'AUDIO':
						// HTML5 Audio/Video APIs
						mediaTag[0].pause();
						break;
					default:
						break;
				}
			}

			const $container = this.$el.find('.mediaContainer');
			$container.removeClass('consume');
			$container.addClass('authoring');
		}

		showConsumeMode() {
			const $container = this.$el.find('.mediaContainer');
			$container.removeClass('authoring');
			$container.addClass('consume');
		}
	}

	return EmbedMedia;
});